export default __webpack_public_path__ + "static/media/target-revenue.2f4c1128.svg";